import { computeCost } from './computeCost';
import { useConfigurationStore } from '@/Store/storeConfiguration';
import { useStoreData } from '@/Store/storeData';

export function getItemsResult() {
    let itemIDs = useConfigurationStore().getAllItemIDs;
    let items = useStoreData().getItemsByIdArr(itemIDs);
    let categories = JSON.parse(JSON.stringify(useStoreData().getCategories));

    const counts = {};
    itemIDs.forEach((x) => {
        counts[x] = (counts[x] || 0) + 1;
    });

    for (let item of items) {
        item.count = counts[item.id];
    }
    const excludedCategoryIds = [ 22, 178 ];
    const excludedItemIds = new Set();

    excludedCategoryIds.forEach(catId => {
        const category = useStoreData().getCategories.find(cat => cat.id === catId);
        if (category) {
            if (category.items) {
                category.items.forEach(id => excludedItemIds.add(+id));
            }
            if (category.sections) {
                category.sections.forEach(section => {
                    if (section.items) {
                        section.items.forEach(id => excludedItemIds.add(+id));
                    }
                });
            }
        }
    });

    const itemsAll = items.map(item => ({ ...item }));
    items = items.filter(item => !excludedItemIds.has(+item.id));

    useStoreData().setCost(computeCost(itemsAll));
    useStoreData().setZeroPrice(items.some(item => item.price != 0));
    useStoreData().countItems = items.length;
    // items.sort((itemPrev, item) => itemPrev.sort - item.sort);
    let dataOut = [];
    Object.values(categories).sort((category1, category2) => category1.sort - category2.sort)
        .forEach(category => {
            if (category.sections) {
                category.sections.sort((sec1, sec2) => sec1.sort - sec2.sort)
                    .forEach(section => {
                        dataOut.push(items.filter(item => section.items.includes(item.id)).sort((item1,item2)=>item1.sort-item2.sort));
                    });
            } else {
                dataOut.push(items.filter(item => category.items.includes(item.id)).sort((item1,item2)=>item1.sort-item2.sort));
            }
        });
    return dataOut.flat();
}
